import { render, staticRenderFns } from "./TodoDetailSidebar.vue?vue&type=template&id=115776e0&scoped=true&"
import script from "./TodoDetailSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoDetailSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoDetailSidebar.vue?vue&type=style&index=0&id=115776e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115776e0",
  null
  
)

/* custom blocks */
import block0 from "@/locales/modules/TodoListTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Ftodo-list%2FTodoDetailSidebar.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locales/components/TimeRepeaterTranslate.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fviews%2Fapps%2Fcbs%2Ftodo-list%2FTodoDetailSidebar.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports